module.exports = __webpack_public_path__ + "assets/images/brandmark.56ecd1f0ce3713412e7b2e63b9e4ac99.svg";